import { Immunology, Oncology, Other } from "../components/Deepchat/AskQuestion/CardIcons";

export const commercialQuestions = [
  {
    title: "Marketing Communications Feedback",
    text: "What is being said about TV Commercials, Advertisements, AND/OR other Marketing Communications?",
    Icon: Other,
  },
  {
    title: "Customer Ad Sentiment",
    text: "What are patients and customers saying about TV Commercials and Advertisements?",
    Icon: Other,
  },
  {
    title: "Marketing Experience Improvement",
    text: "How can customer experience with TV Commercials, Advertisements, and Marketing Communications be improved? Provide clear rationale for your recommendations.",
    Icon: Other,
  },
  {
    title: "Actemra ACT Pen Feedback",
    text: "Can you summarize the feedback regarding the Actmera ACT Pen injector? Make sure to capture all the key points.",
    Icon: Other,
  },
  {
    title: "Actemra ACT Pen Sentiment",
    text: "What are the most important themes and sentiments related to the Actemra ACT Pen injector? Only use context where Actemra ACT Pen injector is explicitly mentioned when responding.",
    Icon: Other,
  },
  {
    title: "Insurance & Medication Access",
    text: "What are customers saying about problems with insurance and medication access?",
    Icon: Other,
  },
  {
    title: "Billing & Cost Concerns",
    text: "What are customers saying about problems related to insurance, billing support, and financial cost of medications?",
    Icon: Other,
  },
  {
    title: "Product Access & Reimbursement",
    text: "What are the main themes and criticisms related to product access, medication billing, and reimbursement?",
    Icon: Other,
  },
  {
    title: "Customer Satisfaction",
    text: "What are some actions Genentech can take to improve customer satisfaction and experience? Provide clear rationale for your recommendations.",
    Icon: Other,
  },
];

export const medicalQuestions = [
  {
    title: "Xolair Food Allergy Feedback",
    text: "Can you summarize the feedback regarding Xolair for Food Allergy? Make sure to capture all the key points.",
    Icon: Immunology,
  },
  {
    title: "Subcutaneous Tecentriq Feedback",
    text: "Can you summarize the feedback regarding the Subcutaneous Tecentriq? Make sure to capture all the key points.",
    Icon: Oncology,
  },
  {
    title: "Ocrevus SubQ Stability",
    text: "What are the most important themes and sentiments related to the stability of Ocrevus SubQ? Only use context where Ocrevus is explicitly mentioned when responding.",
    Icon: Other,
  },
  {
    title: "Health Equity",
    text: "How can patient experience related to Health Equity be improved? Provide clear rationale for your recommendations.",
    Icon: Other,
  },
];

export const salesDataQuestions = [
  {
    title: "Top Drug Sales",
    text: "What're the top drug sales by units in Birmingham last year?",
    Icon: Other,
  },
  {
    title: "Top Ocrevus Accounts",
    text: "Give me the top accounts with the highest Ocrevus sales in q1 2024",
    Icon: Other,
  },
  {
    title: "Product Growth",
    text: "Which products had the largest growth at Johns Hopkins from q4 23 to q1 24?",
    Icon: Other,
  },
];
